import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { useState } from 'react';
import { useCopy } from '@/hooks/useCopy';

export interface CopyToClipboardButtonProps {
  value: string;
  ariaLabel?: string;
  size?: 'small' | 'medium';
  disabled?: boolean;
}

export function CopyToClipboardButton({
  value,
  ariaLabel,
  size = 'small',
  disabled = false,
}: CopyToClipboardButtonProps) {
  const { t } = useCopy();
  const [copied, setCopied] = useState(false);
  const label = ariaLabel ?? t('common.copy', 'Copy');

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  const button = (
    <IconButton onClick={handleClick} aria-label={label} size={size} disabled={disabled}>
      {copied ? <CheckIcon fontSize="inherit" /> : <ContentCopyIcon fontSize="inherit" />}
    </IconButton>
  );

  return (
    <Tooltip title={copied ? t('common.copied', 'Copied') : label}>
      {/* A disabled button fires no events, so the Tooltip anchors to a wrapper. */}
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
